import { callApi } from "@/scripts/useFetch.js";
import { useUserStore } from "@/stores/userStore.js";
import { uuidv4 } from "@/scripts/utils/stringUtils.js";
import Cookies from "js-cookie";

export const getAnonymousID = () => {
    //如果沒有匿名識別碼，則產生一個
    let AnonymousID = Cookies.get(process.env.VUE_APP_AnonymousID);
    if (AnonymousID == null) {
        AnonymousID = uuidv4();
        Cookies.set(process.env.VUE_APP_AnonymousID, AnonymousID, { expires: 365 });
    }
    return AnonymousID;
};

export const redirectToGoogleLogin = (route, router, otherScope) => {
    const currentPage = { name: route.name, params: route.params };
    const returnPage = !!route.meta.loginDirect ? { name: route.meta.loginDirect } : currentPage;

    // 構建 Google OAuth 2.0 授權端點的 URL
    const clientId = process.env.VUE_APP_GoogleClientID;
    const redirectUri = `${window.location.origin}${router.resolve({ name: "GoogleAuthCallback" }).href}`;
    const scope = ["https://www.googleapis.com/auth/userinfo.email", "https://www.googleapis.com/auth/userinfo.profile"];
    if (otherScope) {
        otherScope.forEach((element) => {
            scope.push(element);
        });
    }
    const responseType = "code";
    const accessType = "offline";
    const state = JSON.stringify({ from: route.name, returnPage: returnPage, errorPage: currentPage });
    const authUrl = `https://accounts.google.com/o/oauth2/v2/auth?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${encodeURIComponent(responseType)}&scope=${encodeURIComponent(scope.join(" "))}&access_type=${encodeURIComponent(accessType)}&state=${encodeURIComponent(state)}&include_granted_scopes=true&prompt=select_account`;
    window.location.href = authUrl; // 重定向到 Google 的授權端點
};

export const redirectToTwitchLogin = (route, router) => {
    const currentPage = { name: route.name, params: route.params };
    const returnPage = !!route.meta.loginDirect ? { name: route.meta.loginDirect } : currentPage;

    const clientId = process.env.VUE_APP_TwitchClientID;
    const redirectUri = `${window.location.origin}${router.resolve({ name: "TwitchAuthCallback" }).href}`;
    const scope = ["user:read:email", "chat:edit"];
    const responseType = "code";
    const state = JSON.stringify({ from: route.name, returnPage: returnPage, errorPage: currentPage });
    const authUrl = `https://id.twitch.tv/oauth2/authorize?client_id=${encodeURIComponent(clientId)}&redirect_uri=${encodeURIComponent(redirectUri)}&response_type=${encodeURIComponent(responseType)}&scope=${encodeURIComponent(scope.join(" "))}&state=${encodeURIComponent(state)}`;
    window.location.href = authUrl; // 重定向到 Twitch 的授權端點
};

export const redirectToDiscordLogin = (route, router, otherScope) => {
    const currentPage = { name: route.name, params: route.params };
    //const returnPage = !!route.meta.loginDirect ? { name: route.meta.loginDirect } : currentPage;
    const returnPage = "https://discord.com/channels/1140633721142255807";
    const clientId = process.env.VUE_APP_DiscordClientID;
    const scope = ["identify", "email", "guilds.join"];
    if (otherScope) {
        otherScope.forEach((element) => {
            scope.push(element);
        });
    }
    const state = JSON.stringify({ from: route.name, returnPage: returnPage, errorPage: currentPage });
    const redirectUri = `${window.location.origin}${router.resolve({ name: "DiscordAuthCallback" }).href}`;
    const authUrl = `https://discord.com/api/oauth2/authorize?client_id=${clientId}&response_type=code&redirect_uri=${encodeURIComponent(redirectUri)}&scope=${encodeURIComponent(scope.join(" "))}&prompt=consent&state=${encodeURIComponent(state)}`;
     window.location.href = authUrl; 
}

export const logoutApi = () => {
    return new Promise((resolve, reject) => {
        callApi("Get", "/Auth/Logout")
            .then((json) => {
                if (json.Success) {
                    const userStore = useUserStore();
                    Cookies.remove("auth_token");
                    Cookies.remove(process.env.VUE_APP_AnonymousID); //登出就重新配一組匿名ID
                    userStore.setUserInfo({});
                    resolve(json);
                } else {
                    reject(json);
                }
            })
            .catch((e) => {
                reject(e);
            });
    });
};
